import React from "react";
import Modal from "../../Modal/Modal";
import "./MobileNavModal.css";

const MobileNavModal = ({ 
  isVisible, 
  onClose, 
  onOpenFilters, 
  routes, 
  currentPath, 
  onNavigate 
}) => {
  return (
    <Modal isVisible={isVisible} onClose={onClose}>
      <div className="mobile-nav-modal">
        <h2>Navegación</h2>
        
        {/* Selector de Secciones */}
        <div className="mobile-nav-section">
          <label>📍 Selecciona una sección:</label>
          <select 
            value={currentPath} 
            onChange={(e) => onNavigate(e.target.value)}
            className="mobile-nav-select"
          >
            <option value="">-- Seleccionar --</option>
            {routes.map(({ path, label }) => (
              <option key={path} value={path}>
                {label}
              </option>
            ))}
          </select>
        </div>

        {/* Botón Filtros */}
        <div className="mobile-nav-section">
          <button className="mobile-nav-button" onClick={onOpenFilters}>
            🔧 Abrir Filtros
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default MobileNavModal;
